document.addEventListener('DOMContentLoaded', () => {
  const box = document.querySelector('[data-sapetro-bogo]');
  if (!box) return;
  const button = box.querySelector('[data-bogo-add]');
  const status = box.querySelector('[data-bogo-status]');
  button?.addEventListener('click', async () => {
    const first = box.querySelector('[data-bogo-first]').value;
    const second = box.querySelector('[data-bogo-second]').value;
    button.disabled = true;
    button.textContent = 'Adding your pair…';
    status.textContent = '';
    try {
      const items = first === second
        ? [{ id: Number(first), quantity: 2, properties: { Offer: 'Buy 1 Get 1 Free' } }]
        : [
            { id: Number(first), quantity: 1, properties: { Offer: 'Buy 1 Get 1 Free', Bag: '1' } },
            { id: Number(second), quantity: 1, properties: { Offer: 'Buy 1 Get 1 Free', Bag: '2 – Free' } }
          ];
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Unable to add this pair');
      window.location.href = window.Shopify.routes.root + 'cart';
    } catch (error) {
      status.textContent = 'Please check that both colours are available and try again.';
      button.disabled = false;
      button.textContent = 'Add Both Bags to Cart — ₹599';
    }
  });
});
